export enum EmailsColumnSizes {
  CreatedAt = 16,
  SentFrom = 23,
  SentTo = 23,
  Subject = 30,
  Attachments = 5,
}
